// --- External Libraries
import moment from 'moment';
// --- Components
import { ClickableCellRenderer } from 'datastage/components/AGGrid/cell-renderers/clickable';

export const id = {
    field: 'dealVersionKey.dealId',
    headerName: 'Deal ID',
    width: 200,
};

export const version = {
    field: 'dealVersionKey.version',
    headerName: 'Version',
    width: 150,
    valueFormatter: ({ value, data }) => {
        const subversion = data?.dealVersionKey?.subversion;
        if (subversion > 0) {
            return '';
        }
        return value ?? '';
    },
};

export const snapshot = {
    field: 'snapshotDescription',
    headerName: 'Snapshot',
    width: 150,
    valueFormatter: ({ value }) => value || '',
};

export const deleteSnapshot = (onDeleteSnapshot, isReadOnly) => ({
    headerName: '',
    width: 80,
    cellRenderer: (params) => {
        if (isReadOnly || !params.data?.canDelete) {
            return null;
        }

        return ClickableCellRenderer(onDeleteSnapshot, 'fa-trash')(params);
    },
});

export const title = {
    field: 'body.title',
    tooltip: 'body.title',
    headerName: 'Deal Title',
    width: 625,
    wrapText: true,
    autoHeight: true,
    cellStyle: { 
        paddingTop: '10px', 
        paddingBottom: '10px',
        wordBreak: 'normal',
        overflowWrap: 'break-word',
    },
};

export const template = {
    field: 'body.template.templateName',
    headerName: 'Template',
    width: 550,
};

export const pdf = (
    downloadPDF,
) => ({
    headerName: 'PDF',
    cellRenderer: ClickableCellRenderer(downloadPDF, 'fa-file-pdf'),
    width: 125,
});

export const xlsx = (
    downloadPDF,
    downloadXLSX,
) => ({
    headerName: 'XLSX',
    cellRenderer: ClickableCellRenderer(downloadXLSX, 'fa-file-excel'),
    width: 125,
});

export const created = {
    field: 'createdAt',
    headerName: 'Created',
    valueFormatter: ({ value }) => (value ? moment(moment(value).local().format('YYYY-MM-DD[T]HH:mm:ss')).format('MMM-DD-YYYY, h:mm:ss A z') : ''),
    width: 348,
};
